module.exports = __webpack_public_path__ + "static/img/信息管理系统.da07878.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/webSite/著作权/信息管理系统.png
// module id = 2t4/
// module chunks = 1